<template>
  <v-card>
    <v-row class="my-0">
      <v-col cols="12" :lg="view === 'dashboard top'? '6':'12'">
        <v-card-title font-family="Poppins">Revenue & Expenses</v-card-title>
      </v-col>
      <v-col v-show="view === 'dashboard top'" class="pt-0 text-right" cols="12" lg="6">
        <v-btn-toggle v-model="dashboardRange" class="pa-2" color="secondary" group exclusive>
          <v-btn small class="pa-4">
            3 Months
          </v-btn>

          <v-btn small class="pa-4">
            6 Months
          </v-btn>

          <v-btn small class="pa-4">
            12 Months
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card-text v-if="percentDif > 0 && chartValues.length > 0 && percentDifExpense < 0" class="pt-0">
      <p class="mb-2">
        <v-icon class="mdi mdi-circle success--text mb-1" size="15"></v-icon>
        Revenue
        <v-icon class="mdi mdi-arrow-up success--text mb-1" size="15"></v-icon>
        <span class="success--text">{{ Math.abs(percentDif) }}%</span>
      </p>
      <p class="mb-2">
        <v-icon class="mdi mdi-circle error--text accent-3 mb-1" size="15"></v-icon>
        Expenses
        <v-icon class="mdi mdi-arrow-down success--text mb-1" size="15"></v-icon>
        <span class="success--text">{{ Math.abs(percentDifExpense) }}%</span>
      </p>
    </v-card-text>

    <v-card-text v-if="percentDif < 0 && chartValues.length > 0 && percentDifExpense > 0" class="pt-0">
      <div class="mb-2">
        <v-icon class="mdi mdi-circle success--text lighten-1 mb-1" size="15"></v-icon>
        Revenue
        <v-icon class="mdi mdi-arrow-down success--text mb-1" size="15"></v-icon>
        <span class="success--text">{{ Math.abs(percentDif) }}%</span>
      </div>
      <div class="mb-2">
        <v-icon class="mdi mdi-circle error--text accent-3 mb-1" size="15"></v-icon>
        Expenses
        <v-icon class="mdi mdi-arrow-up error--text mb-1" size="15"></v-icon>
        <span class="error--text">{{ Math.abs(percentDifExpense) }}%</span>
      </div>
    </v-card-text>

    <v-card-text v-if="percentDif < 0 && chartValues.length > 0 && percentDifExpense < 0" class="pt-0">
      <div class="mb-2">
        <v-icon class="mdi mdi-circle success--text lighten-1 mb-1" size="15"></v-icon>
        Revenue
        <v-icon class="mdi mdi-arrow-down error--text mb-1" size="15"></v-icon>
        <span class="error--text">{{ Math.abs(percentDif) }}%</span>
      </div>
      <div class="mb-2">
        <v-icon class="mdi mdi-circle error--text accent-3 mb-1" size="15"></v-icon>
        Expenses
        <v-icon class="mdi mdi-arrow-down success--text mb-1" size="15"></v-icon>
        <span class="success--text">{{ Math.abs(percentDifExpense) }}%</span>
      </div>
    </v-card-text>

    <v-card-text v-if="percentDif > 0 && chartValues.length > 0 && percentDifExpense > 0" class="pt-0">
      <div class="mb-2">
        <v-icon class="mdi mdi-circle success--text lighten-1 mb-1" size="15"></v-icon>
        Revenue
        <v-icon class="mdi mdi-arrow-up success--text mb-1" size="15"></v-icon>
        <span class="success--text">{{ Math.abs(percentDif) }}%</span>
      </div>
      <div class="mb-2">
        <v-icon class="mdi mdi-circle error--text accent-3 mb-1" size="15"></v-icon>
        Expenses
        <v-icon class="mdi mdi-arrow-up error--text mb-1" size="15"></v-icon>
        <span class="error--text">{{ Math.abs(percentDifExpense) }}%</span>
      </div>
    </v-card-text>

    <v-card-text v-if="percentDif === 0 && chartValues.length > 0" class="pt-0">
      <div class="mb-2">
        <v-icon class="mdi mdi-circle success--text lighten-1 mb-1" size="15"></v-icon>
        Revenue
        <v-icon class="mdi mdi-swap-vertical mb-1" size="15"></v-icon>
        0%
      </div>
      <div class="mb-2">
        <v-icon class="mdi mdi-circle error--text accent-3 mb-1" size="15"></v-icon>
        Expenses
        <v-icon class="mdi mdi-swap-vertical mb-1" size="15"></v-icon>
        0%
      </div>
    </v-card-text>

    <v-card-text v-if="chartValues.length < 1" class="pt-0">
      <div class="mb-2">
        <v-icon class="mdi mdi-circle success--text lighten-1 mb-1" size="15"></v-icon>
        Revenue
      </div>
      <div class="mb-2">
        <v-icon class="mdi mdi-circle error--text accent-3 mb-1" size="15"></v-icon>
        Expenses
      </div>
      <v-alert type="info" class="text-body-2">
        No Data for selected input
      </v-alert>
      <v-divider class="my-2"></v-divider>
    </v-card-text>

    <div class="pa-3">
      <line-chart 
        :data="dataCollection" 
        :options="options" 
        :styles="myStyles" 
        :chart="'revExp'" 
      />
    </div>
  </v-card>
</template>

<script>
import LineChart from "../charts/LineChart";

export default {
  components: {
    LineChart
  },
  props: ["chartInfo", "view"],
  data() {
    return {
      dataCollection: null,
      dashboardRange: null,
      chartMonths: [],
      chartValues: [],
      expenseValues: [],
      percentDif: 0,
      percentDifExpense: 0,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              let value1 = data.datasets[0].data[tooltipItem.index];
              let value2 = data.datasets[1].data[tooltipItem.index];
              if (tooltipItem.datasetIndex === 0) {
                  if (parseInt(value1) >= 1000 && parseInt(value2) >= 1000) {
                    return `$${value1.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
                  }
                  return `$${value}`;
              } else if (tooltipItem.datasetIndex === 1) {
                  if (parseInt(value1) >= 1000 && parseInt(value2) >= 1000) {
                    return `$${value2.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
                  }
                  return `$${value}`;
              }
              
            }
          }
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "Months"
              },
              gridLines: {
                color: "rgba(61, 97, 133, 0.25)",
                display: true,
                drawBorder: false,
                drawTicks: false
              },
              ticks: {
                padding: 10
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Revenue / Expenses ($)"
              },
              gridLines: {
                display: false
              },
              ticks: {
                callback(value, index, values) {
                  if (parseInt(value) >= 1000) {
                    return `$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
                  }
                  return `$${value}`;
                },
              },
            }
          ]
        }
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.chartMonths = [];
      this.chartValues = [];
      this.expenseValues = [];

      this.chartInfo.forEach(info => {
        this.chartMonths.push(info._id.month);
        this.chartValues.push(info.revenue);
        this.expenseValues.push(info.expenses);
      });
      this.getPercentDif();
      this.getPercentDifExpenses();
    },
    chartData() {
      this.dataCollection = {
        labels: this.chartMonths,
        datasets: [
          {
            label: "Revenue",
            borderColor: "#3bb273",
            pointBackgroundColor: "#3bb273",
            borderWidth: 3,
            data: this.chartValues
          },
          {
            label: "Expenses",
            borderColor: "#e15554",
            pointBackgroundColor: "#e15554",
            borderWidth: 3,
            data: this.expenseValues
          }
        ]
      };
    },
    async getPercentDif() {
      // check for undefined values
      const firstVal = this.chartValues[0] ? this.chartValues[0] : 0;
      const lastVal = this.chartValues[this.chartValues.length - 1]
        ? this.chartValues[this.chartValues.length - 1]
        : 0;

      const decreaseValue = firstVal - lastVal;
      this.percentDif =
        firstVal !== 0
          ? Math.ceil(((decreaseValue / firstVal) * 100) * (-1))
          : Math.ceil(decreaseValue * 100);
      this.loading = false;
    },
    async getPercentDifExpenses() {
      const decreaseValue =
      this.expenseValues[0] - this.expenseValues[this.expenseValues.length - 1];
      this.percentDifExpense = Math.ceil(((decreaseValue / this.expenseValues[0]) * 100) * (-1));
      this.loading = false;
    }
  },
  watch: {
    async chartValues() {
      this.chartData();
    },
    async chartInfo() {
      this.getData();
    },
    async dashboardRange() {
      this.$emit("dashboardRange", this.dashboardRange);
    }
  },
  computed: {
    myStyles() {
      if (this.view === "dashboard") {
        return {
          height: "30vh"
        };
      }
    }
  }
};
</script>
